interface ReplaceWord {
  base: string,
  replace: string
}

/** インクリメンタルサーチで置換をする単語リスト */
export const replaceWordList: ReplaceWord[] = [
  {
    base: '宇部興産',
    replace: '宇部興産株式会社'
  }
];

/** インクリメンタルサーチで無視をする単語リスト */
export const ignoreWordList: string[] = [
  '現在地'
]